export const practiceSidebar = (isAdmin) => [
  { path: '', name: 'Dashboard', icon: 'dashboard-mono', end: true },
  { path: 'appointments', name: 'Calendar', icon: 'calendar-mono', end: false },
  {
    path: 'charts',
    name: 'Charts',
    permission: 'patients.read',
    icon: 'users-mono',
    end: false
  },
  {
    path: 'beyond-billing',
    name: 'Beyond Billing',
    icon: 'billing-mono',
    permission: 'billing.read',
    end: false,
    children: [
      { path: 'beyond-billing/overview', name: 'Overview', icon: 'graph-mono' },
      {
        path: 'beyond-billing/income-i-queue',
        name: 'IncomeIQueue',
        icon: 'note-text-1-mono',
        permission: 'is_admin'
      },
      {
        name: 'Payments',
        path: 'beyond-billing/payments',
        icon: 'billing-mono',
        permission: 'payments.read'
      },
      {
        path: 'beyond-billing/patient-ledger',
        name: 'Patient Ledger',
        icon: 'macro-mono',
        permission: 'payments.read'
      },
      // {
      //   path: 'beyond-billing/financial-reporting',
      //   name: 'Financial Reporting',
      //   icon: 'receipt-2-mono'
      // },
      // {
      //   path: 'beyond-billing/dynamic-ar',
      //   name: 'Dynamic AR',
      //   icon: 'note-mono'
      // },
      { path: 'beyond-billing/era-eob/era', name: 'ERA', icon: 'receipt-1-mono' },
      { path: 'beyond-billing/era-eob/eob', name: 'EOB', icon: 'receipt-3-mono' },
      { path: 'beyond-billing/claims', name: 'Claims', icon: 'wallet-mono' },
      {
        path: 'beyond-billing/superbills',
        name: 'Superbills',
        icon: 'billing-mono',
        permission: 'superbill.read'
      },
      {
        path: 'beyond-billing/electronic-invoicing',
        name: 'Electronic Invoicing',
        icon: 'file-invoice-mono'
      },
      {
        path: 'beyond-billing/reports',
        name: 'Reports',
        icon: 'graph-mono',
        permission: 'reports.read'
      }
    ]
  },
  { path: 'comms-center', name: 'Comms Center', icon: 'modules-mono', end: false },
  {
    path: 'documents',
    name: 'Documents',
    permission: 'patient_documents_center.read',
    icon: 'first-line-mono',
    end: false
  },
  {
    path: 'practice-i-queue',
    name: 'PracticeIQueue',
    icon: 'practiceiqueue-filled',
    end: false,
    children: [
      { name: 'Overview', path: 'practice-i-queue/overview', icon: 'graph-mono' },
      {
        name: 'Tasks',
        path: 'practice-i-queue/tasks',
        icon: 'task-mono',
        permission: 'tasks.read'
      },
      {
        name: 'Clinical Notes',
        path: 'practice-i-queue/clinical-notes',
        icon: 'note-mono',
        permission: 'clinical_note.read'
      },
      {
        name: 'Treatment Plans',
        path: 'practice-i-queue/treatment-plans',
        icon: 'task-1-linear',
        permission: 'clinical_note.read'
      },
      { name: 'Notifications', path: 'practice-i-queue/notifications', icon: 'bell-mono' },
      {
        name: 'Appointments',
        path: 'practice-i-queue/appointments',
        icon: 'calendar-mono',
        permission: 'appointments.read'
      },
      {
        name: 'Forms',
        path: 'practice-i-queue/forms',
        icon: 'calendar-note-mono',
        permission: 'form_packet.read'
      },
      isAdmin
        ? {
            name: 'Orders',
            path: 'practice-i-queue/orders',
            icon: 'note-text-1-mono',
            permission: ''
          }
        : null
    ].filter(Boolean)
  },
  {
    path: 'settings',
    name: 'Settings',
    icon: 'settings-mono',
    end: false,
    children: [
      {
        path: 'settings',
        name: 'Services',
        icon: 'star-1-filled',
        permission: 'services.read',
        end: true
      },
      {
        path: 'settings/products',
        name: 'Products',
        permission: 'products.read',
        icon: 'pill-mono'
      },
      {
        path: 'settings/packages',
        name: 'Packages',
        icon: 'packages-mono',
        permission: 'packages.read'
      },
      { path: 'settings/calendar', name: 'Calendar', icon: 'calendar-2-mono' },
      {
        path: 'settings/forms',
        name: 'Forms',
        icon: 'calendar-note-mono',
        permission: 'form.read'
      },
      { path: 'settings/payers', name: 'Payers', icon: 'payers-mono' },
      { path: 'settings/account', name: 'Account', icon: 'user-square-mono' },
      {
        path: 'settings/staff',
        name: 'Staff',
        permission: 'member.read',
        icon: 'people-mono'
      },
      {
        path: 'settings/roles',
        name: 'Roles & Permissions',
        permission: 'role.read',
        icon: 'users-mono'
      },
      {
        path: 'settings/eprescribe',
        name: 'ePrescribe',
        permission: 'prescribe.read',
        icon: 'prescribe-mono'
      },
      {
        path: 'settings/billing',
        name: 'Billing',
        permission: 'billing.read',
        icon: 'wallet-mono'
      },
      { path: 'settings/kiosk', name: 'Kiosk', permission: 'kiosk.read', icon: 'kiosk-mono' },
      {
        path: 'settings/resources',
        name: 'Resources',
        icon: 'menu-board-mono',
        permission: 'resources.read'
      },
      { path: 'settings/tags', name: 'Tags', icon: 'tag-mono', permission: 'tags.read' }
    ]
  }
];
